import React from 'react'
import ReactDOM from 'react-dom/client'
import { initSupabase } from '@fpv-boats/supabase'
import { I18nProvider } from '@aqua-rush/i18n'
import App from './App'

// Initialize Supabase with env vars from this app's build
initSupabase(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_ANON_KEY
)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <I18nProvider>
      <App />
    </I18nProvider>
  </React.StrictMode>,
)
